<template>
  <div class="Collect">
    <div class="page-title">{{$t('title.collection')}}</div>
    <div class="row-splitter">
      <ATable
        ref="table_customer"
        v-loading="loading_customer"
        :data="tableDataCustomerSale"
        :placeholder="searchPlaceHolder"
        :summaryTitleColumnIndex="2"
        :summaryFields="summaryFields"
        :search_field="search_field"
        max-height="420px"
        show-summary
        hide-button-insert
        hide-pagination
        highlight-current-row
        border
        @current-change="handleCurrentChange"
      >
        <div slot="search">
          <div class="inline">
            <APeriodSelector 
              ref="period" 
              :value="search_period"
              hide-select
              @change="handleChangePeriod" 
            />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
            >검색(F5)</el-button>
          </div>
        </div>
        <el-table-column
          type="index"
          label="No"
          :index="handleIndexCustomerSale"
          :width="$width.indexw"
        />
        <el-table-column prop="name" label="거래처" show-overflow-tooltip />
        <el-table-column prop="location" label="사업장" show-overflow-tooltip />
        <el-table-column
          prop="sum_income"
          label="매출액"          
          class-name="cell-number"
          width="100"
          :formatter="util.numberFormat"
        />        
        <el-table-column
          prop="sum_collected"
          label="수금"
          class-name="cell-number"
          width="100"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="balance"
          label="미수금"
          class-name="cell-number"
          width="100"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="credit_line"
          label="여신 한도"
          class-name="cell-number"
          width="100"
          :formatter="util.numberFormat"
        />
        <el-table-column
          label="상태"
          width="80"
          :formatter="resolveStatus"
        />
        <el-table-column
          prop="modified_at"
          label="변경일"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
      </ATable>
    </div>
    <div class="row-splitter">
      <el-row :gutter="10">
        <el-col :span="6">
          <el-input 
            placeholder="거래처" 
            v-model="customer.customer_name" 
            readonly
          >
            <template slot="prepend">거래처</template>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input 
            placeholder="사업장" 
            v-model="customer.location" 
            readonly
          >
            <template slot="prepend">사업장</template>
          </el-input>
        </el-col>
        <el-col :span="5">
          <el-input 
            placeholder="매출액" 
            class="right"
            :value="util.addComma(customer.balance)" 
            readonly
          >
            <template slot="prepend">미수금</template>
          </el-input>
        </el-col>
        <el-col :span="5">
          <el-input 
            placeholder="여신 한도" 
            class="right"
            :value="util.addComma(customer.credit_line)" 
            readonly
          >
            <template slot="prepend">여신 한도</template>
          </el-input>
        </el-col>
      </el-row>
    </div>
    <div class="row-splitter">
      <ATable
        ref="table_contract"
        class="no-pointer"
        v-loading="loading_collect"
        max-height="300px"
        :data="filterDataCollect"
        hide-button-insert
        hide-pagination
        border
      >
        <div slot="search" class="list-title">수금 리스트</div>
        <el-table-column
          type="index"
          label="No"
          :index="handleIndexCollect"
          :width="$width.indexw"
        />
        <el-table-column
          prop="collect_way_flag"
          label="수금 방법"
          width="150"
          :formatter="resolveCollectWay"
        />
        <el-table-column
          prop="collect_date"
          label="수금 일자"
          :formatter="util.dateFormat"
          :width="$width.date"
        />
        <el-table-column
          prop="price"
          label="수금액"
          class-name="cell-number"
          width="120"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="discount_price"
          label="할인액"
          class-name="cell-number"
          width="120"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="balance"
          label="잔액"
          class-name="cell-number"
          width="120"
          :formatter="util.numberFormat"
        />
        <el-table-column 
          label="비고" 
          prop="desc"
          show-overflow-tooltip
        />
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
      </ATable>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { account_form } from "@/common/mixins/account_form";

export default {
  name: "Collect",
  mixins: [account_form],
  data() {
    return {
      title: this.$t("title.collection"),
      period: {},      
      searchPlaceHolder: "거래처, 사업장",
      search_field: ["name", "location"],
      summaryFields: ['sum_income','sum_collected','balance'],
      searchWord: null,
      fixedSearchWord: "",
      pageSize: 10,
      loading_customer: false,
      items_customer: [],
      customer: {},
      loading_collect: false,
      items_collect: [],
      search_period: {value: '0d'},
    };
  },
  computed: {
    ...mapGetters(["table_customer"]),
    pay_way_flag_options: function() {
      return this.system.options.pay_way_flag;
    },
    /* 매출 */
    filterDataCustomerSale: function() {
      return this.util.filterMultiFields(
        this.items_customer,
        this.search_fieldCustomerSale,
        this.fixedSearchWord
      );
    },
    recordCountCustomerSale() {
      return this.filterDataCustomerSale.length;
    },
    tableDataCustomerSale() {
      return this.filterDataCustomerSale;
    },
    filterDataCollect: function() {
      // return this.util.filterMultiFields(this.items_collect, this.search_fieldSale, this.fixedSearchWord);
      let items = this.items_collect;
      items.sort((a, b) => {
        return b.id - a.id;
      });
      return this.items_collect;
    },
    recordCountCollect() {
      return this.filterDataCollect.length;
    },
  },
  mounted() {
    this.$nextTick(() => this.handleClickSearch());
  },
  methods: {
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) {return;}
      this.loadData();
    },
    handleClickFilter() {
      this.fixedSearchWord = this.searchWord;
      this.selectFirstCustomer();
    },
    selectFirstCustomer(id) {
      this.$nextTick(() => {
        let table = this.$refs.table_customer;
        let data = table.data;
        if (data) {
          let row = data.find(item => item.id === id);
          setTimeout(() => {
            table.setCurrentRow(id ? row : data[0]);
          }, 100);
        }
      });
    },
    loadData(id) {
      this.loading_customer = true;
      this.api.listCollectSum(this.period).then(res => {
        this.loading_customer = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items_customer = this.organizeData(res.data);
        this.selectFirstCustomer(id);
      });
    },
    organizeData(items) {
      items.forEach(item => {
        let c = this.table_customer.find(c => c.id === item.id);
        if (!c) { return true; }
        item.name = c.name;
        item.location = c.location;
        item.credit_line = c.credit_line;
      });
      return items.sort(this.sortItems);
    }, 
    sortItems(a, b) {      
      if (a.modified_at !== b.modified_at) {
        return a.modified_at > b.modified_at ? -1 : 1;
      } else {        
        return a.name > b.name ? 1 : -1;
      }
    },
    handleIndexCustomerSale(index) {
      return this.$refs.table_customer.indexResolver(index);
    },
    resolveStatus(row) {
      if (!row.credit_line) return "진행";
      return row.sum_uncollected > row.credit_line ? "거래중지" : "진행";
    },
    handleCurrentChange(currentRow/*, oldCurrentRow*/) {
      this.customer = currentRow ? currentRow[0] : {};
      this.customer.customer_id = this.customer.id;
      this.customer.customer_name = this.customer.name;
      this.loadCollect();
    },
    loadCollect() {
      let customer_id = this.customer.id;
      if (!customer_id) {
        this.items_collect = [];
        return;
      }
      this.loading_collect = true;
      this.api.listCollectByCustomer(customer_id, this.period).then(res => {
        this.loading_collect = false;
        if (res.error !== this.system.noError) {
          this.util.notify_error(
            this,
            this.$t("title.collection"),
            res.message
          );
          return;
        }
        this.items_collect = res.data;
      });
    },
    handleIndexCollect(index) {
      return this.$refs.table_contract.indexResolver(index);
    },
    handleCurrentChangeCollect(value) {
      this.currentPageCollect = value;
    },
    resolveCollectWay(row, cell, value) { 
      if( value == '2' ) {
        return this.getBankAccountName(row.account_id);
      }

      let collect_way = this.system.options.collect_way_flag.find(item => {
        return item.value == value;
      });      
      return collect_way ? collect_way.label : null;
    },    
  }
};
</script>
